import React from 'react';
import MuiModal from '../../mui/MuiModal/MuiModal';
import styles from './PremiumSubscriptionRequiredModal.module.scss';
import { Link, Typography } from '@mui/material';
import { FlattenedUser } from '../../types/user';
import { useSelector } from 'react-redux';
import rpc from '@rockpapercoin/rpc-shared';
import { UserType } from '#types';
import { Button } from '../../blocks/Button';

export type PremiumSubscriptionRequiredModalProps = {
	open: boolean;
	onClose: () => void;
};

export const PremiumSubscriptionRequiredModal: React.FC<
	PremiumSubscriptionRequiredModalProps
> = ( { open, onClose } ) => {
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );
	const orgUser =
		user?.isLoggedIn && user.userType === UserType.OrgUser ? user : undefined;
	const isAdmin = orgUser
		? rpc.organizations.isAdmin( orgUser.organization, orgUser )
		: false;
	return (
		<MuiModal
			controls={
				!isAdmin ? <Button onClick={ onClose }>Got it</Button> : undefined
			}
			muiModalProps={ {
				open,
				onClose,
				slotProps: { paper: { 'data-cy': 'premium-subscription-required' } },
			} }
			title='Premium subscription required'
			description={
				<>
					{ isAdmin ? (
						<Typography component='span' className={ styles.paragraph }>
							You can purchase a Premium subscription on the{ ' ' }
							<Link href='/admin?tab=subscription' onClick={ onClose }>
								Subscription tab of your admin page
							</Link>
							, or get in touch with one of our team members for assistance.
						</Typography>
					) : (
						<Typography component='span' className={ styles.paragraph }>
							Hey, it looks like you're trying to access leads! This requires a
							premium subscription which can be turned on by an admin at your
							organization.
						</Typography>
					) }
				</>
			}
		/>
	);
};
